var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTxt = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 40,
  fill: "currentColor",
  viewBox: "0 0 34 40",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M23.074 11.67c-.955 0-1.737-.72-1.737-1.6V0H4.34C1.953 0 0 1.8 0 4.001V36c0 2.199 1.953 4 4.34 4h25.32c2.387 0 4.34-1.8 4.34-4.001v-24.33z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DEE7FA",
  d: "M22.949 11.66h11.047L21.348 0v10.181c.061.79.744 1.422 1.6 1.478Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#095FF9",
  d: "M33.997 19.963v-8.248H23.033z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.863 33.054V35H7.17v-1.946h1.694ZM9.2 28.98v-1.26h1.148v-1.96h1.582v1.96h1.806v1.26H11.93v3.808q0 .56.224.812.239.252.686.252.238 0 .448-.028.224-.028.434-.098l.238 1.19q-.672.224-1.456.224-1.203 0-1.68-.616-.476-.63-.476-1.876V28.98zm5.412-1.26h1.876l1.484 2.324 1.596-2.324h1.666l-2.366 3.43 2.59 3.85H19.61l-1.736-2.66L16.11 35h-1.736l2.646-3.78zm7.099 1.26v-1.26h1.148v-1.96h1.582v1.96h1.806v1.26H24.44v3.808q0 .56.224.812.237.252.686.252.237 0 .448-.028.224-.028.434-.098l.238 1.19q-.673.224-1.456.224-1.205 0-1.68-.616-.477-.63-.476-1.876V28.98z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTxt);
export default ForwardRef;